import { Box, Card, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export type NoteSectionProps = {
  title?: string;
  disabled?: boolean;
  onDelete?: React.ReactElement;
  className?: string;
};

export const NoteSection: React.FC<NoteSectionProps> = ({ title, disabled, children, onDelete, className }) => {
  const { classes, cx } = useStyles();

  return (
    <Card variant="outlined" className={cx(classes.section, disabled && classes.disabled)}>
      {title && (
        <Box className={cx(classes.title, children && classes.shadow)}>
          <Typography variant="h5">
            {title}
          </Typography>
          {onDelete}
        </Box>

      )}
      {children && (
        <Box className={className ? className : classes.content}>
          {children}
        </Box>
      )}
    </Card>
  );
};

const useStyles = makeStyles({ name: 'NotesSection' })(theme => ({
  content: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  disabled: {
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.text.disabled,
    cursor: 'not-allowed',
    pointerEvents: 'none'
  },
  section: {
    width: '100%',
  },
  shadow: {
    boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.12)',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3),
    '& h5': {
      fontWeight: 450
    }
  }
}));
